module.exports = __webpack_public_path__ + "d4fe2051e46c95649f888fcee1412ca7.png";